import { render } from "./CommonButton.vue?vue&type=template&id=083b820a&scoped=true"
import script from "./CommonButton.vue?vue&type=script&lang=js"
export * from "./CommonButton.vue?vue&type=script&lang=js"

import "./CommonButton.vue?vue&type=style&index=0&id=083b820a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083b820a"]])

export default __exports__